import { useAuth } from 'app/modules/auth';
import db from 'services/firebase';
import {useEffect, useState} from 'react'
import {collection, doc, query, where, getDocs} from 'firebase/firestore'

interface OwnerDisplayProps {
  owner?: string;
  uid?: string;
  firstNameOnly?: boolean;
}

const OwnerDisplay: React.FC<OwnerDisplayProps> = ({ owner, uid, firstNameOnly }) => {
  const {currentUser} = useAuth()
  const [avatarUrl, setAvatarUrl] = useState<string | undefined>(undefined)

  useEffect(() => {
    if (uid) {
      getOwnerImage()
    }
  }, [uid])

  const getOwnerImage = async () => {
    try {
      const tenantId = currentUser?.tenantId || ''
      if (!tenantId || !uid) return

      const tenantRef = doc(db, 'tenants', tenantId)
      const employeesRef = collection(tenantRef, 'employees')
      
      const q = query(employeesRef, where('uid', '==', uid))
      const querySnapshot = await getDocs(q)
      
      if (!querySnapshot.empty) {
        const employeeData = querySnapshot.docs[0].data()
        const imageUrl = employeeData.image_url || employeeData.photo_url || ''
        setAvatarUrl(imageUrl)
      } else {
        setAvatarUrl('')
      }
    } catch (error) {
      setAvatarUrl('')
    }
  }

  const isValidOwner = owner && typeof owner === 'string' && owner.trim().length > 0

  return (
    <div className="d-flex align-items-center">
      {isValidOwner ? (
        <>
          <div className="symbol symbol-25px me-3">
            {avatarUrl ? (
              <img
                src={avatarUrl}
                alt={owner}
                className="symbol-label fs-7 fw-bold"
                style={{ 
                  width: '25px', 
                  height: '25px', 
                  objectFit: 'cover',
                  backgroundColor: '#F5F5F5', 
                  border: '1px solid #E5E5E5'
                }}
              />
            ) : (
              <span
                className="symbol-label fs-7 fw-bold"
                style={{ backgroundColor: '#F5F5F5', border: '1px solid #E5E5E5' }}
              >
                {owner.charAt(0).toUpperCase()}
              </span>
            )}
          </div>
          {!firstNameOnly && (
            <div className="d-flex justify-content-start flex-column">
              <span className="text-gray-900 fw-semibold fs-7">{owner}</span>
            </div>
          )}
        </>
      ) : (
        <>--</>
      )}
    </div>
  );
};

export default OwnerDisplay;